export default "__VITE_ASSET__BwYIwLVX__"